/**
 * R.H.I.E. - Ritual & Habit Intelligence Engine
 * Central Event Bus - Tek Doğruluk Kaynağı
 * 
 * Tüm motor, UI ve rehber bu event bus üzerinden haberleşir.
 */

// ==========================================
// EVENT TANIMLARI
// ==========================================

export const RHIE_EVENTS = {
  // Ritüel Motorları Events
  RITUAL_STARTED: 'rhie:ritual:started',
  RITUAL_COMPLETED: 'rhie:ritual:completed',
  RITUAL_SKIPPED: 'rhie:ritual:skipped',
  RITUAL_PAUSED: 'rhie:ritual:paused',
  RITUAL_RESUMED: 'rhie:ritual:resumed',
  RITUAL_PROGRESS: 'rhie:ritual:progress',
  
  // Ritüel Sürekliliği Events
  STREAK_EXTENDED: 'rhie:streak:extended',
  STREAK_BROKEN: 'rhie:streak:broken',
  STREAK_AT_RISK: 'rhie:streak:at_risk',
  STREAK_MILESTONE: 'rhie:streak:milestone', // 7, 21, 30, 66 gün dönüşüm adımları
  
  // Gamification Events
  XP_EARNED: 'rhie:xp:earned',
  LEVEL_UP: 'rhie:level:up',
  BADGE_EARNED: 'rhie:badge:earned',
  CHALLENGE_STARTED: 'rhie:challenge:started',
  CHALLENGE_COMPLETED: 'rhie:challenge:completed',
  
  // AI Öneri Events (P2 Genişletilmiş)
  AI_SUGGESTION_READY: 'rhie:ai:suggestion_ready',
  AI_DROP_RISK_DETECTED: 'rhie:ai:drop_risk',
  AI_MOOD_ANALYZED: 'rhie:ai:mood_analyzed',
  AI_RECOMMENDATION_SHOWN: 'rhie:ai:recommendation_shown',
  AI_RECOMMENDATION_ACCEPTED: 'rhie:ai:recommendation_accepted',
  AI_RECOMMENDATION_REJECTED: 'rhie:ai:recommendation_rejected',
  AI_WINBACK_TRIGGERED: 'rhie:ai:winback_triggered',
  
  // Drop Risk Events (P2 Yeni)
  DROP_RISK_LOW: 'rhie:drop_risk:low',
  DROP_RISK_MEDIUM: 'rhie:drop_risk:medium',
  DROP_RISK_HIGH: 'rhie:drop_risk:high',
  DROP_RISK_CRITICAL: 'rhie:drop_risk:critical',
  DROP_RISK_RECOVERED: 'rhie:drop_risk:recovered',
  
  // Motivasyon Events (P2 Yeni)
  MOTIVATION_LOW: 'rhie:motivation:low',
  MOTIVATION_BOOST_NEEDED: 'rhie:motivation:boost_needed',
  MOTIVATION_RESTORED: 'rhie:motivation:restored',
  
  // ==========================================
  // P3 - MindCare Maintenance Engine Events
  // ==========================================
  
  // Maintenance Core Events
  MAINTENANCE_TRIGGERED: 'rhie:maintenance:triggered',
  MAINTENANCE_CHECK_COMPLETE: 'rhie:maintenance:check_complete',
  MAINTENANCE_REPORT_READY: 'rhie:maintenance:report_ready',
  
  // Süreklilik Kalkanı Events (Grace Period)
  STREAK_SHIELD_AVAILABLE: 'rhie:shield:available',
  STREAK_SHIELD_ACTIVATED: 'rhie:shield:activated',
  STREAK_SHIELD_USED: 'rhie:shield:used',
  STREAK_SHIELD_EXPIRED: 'rhie:shield:expired',
  STREAK_FREEZE_ACTIVATED: 'rhie:shield:freeze_activated',
  
  // Partial Completion Events
  PARTIAL_COMPLETION_DETECTED: 'rhie:partial:detected',
  PARTIAL_COMPLETION_CREDITED: 'rhie:partial:credited',
  PARTIAL_TO_FULL_UPGRADE: 'rhie:partial:upgraded',
  
  // Buffer Day Events
  BUFFER_DAY_GRANTED: 'rhie:buffer:granted',
  BUFFER_DAY_USED: 'rhie:buffer:used',
  BUFFER_DAYS_DEPLETED: 'rhie:buffer:depleted',
  
  // Recovery Events
  RECOVERY_RITUAL_SUGGESTED: 'rhie:recovery:suggested',
  RECOVERY_RITUAL_STARTED: 'rhie:recovery:started',
  RECOVERY_RITUAL_COMPLETE: 'rhie:recovery:complete',
  RECOVERY_STREAK_RESTORED: 'rhie:recovery:streak_restored',
  
  // Weekly Rhythm Events
  WEEKLY_REPORT_READY: 'rhie:weekly:report_ready',
  WEEKLY_GOAL_SET: 'rhie:weekly:goal_set',
  WEEKLY_GOAL_ACHIEVED: 'rhie:weekly:achieved',
  WEEKLY_RHYTHM_BROKEN: 'rhie:weekly:rhythm_broken',
  WEEKLY_CONSISTENCY_IMPROVED: 'rhie:weekly:improved',
  
  // Grace Mode Events (Tatil/Sağlık)
  GRACE_MODE_REQUESTED: 'rhie:grace:requested',
  GRACE_MODE_ACTIVATED: 'rhie:grace:activated',
  GRACE_MODE_ENDED: 'rhie:grace:ended',
  GRACE_WELCOME_BACK: 'rhie:grace:welcome_back',
  
  // New User Support Events
  NEW_USER_DETECTED: 'rhie:newuser:detected',
  NEW_USER_FIRST_RITUAL: 'rhie:newuser:first_ritual',
  NEW_USER_FIRST_STREAK: 'rhie:newuser:first_streak',
  NEW_USER_GRADUATED: 'rhie:newuser:graduated',
  
  // ==========================================
  // P4 - Growth Layer Events
  // ==========================================
  
  // OAuth Events
  OAUTH_LOGIN_STARTED: 'rhie:oauth:login_started',
  OAUTH_LOGIN_SUCCESS: 'rhie:oauth:login_success',
  OAUTH_LOGIN_FAILED: 'rhie:oauth:login_failed',
  OAUTH_ACCOUNT_LINKED: 'rhie:oauth:account_linked',
  
  // Kapı Açma (Referral) Events
  REFERRAL_CODE_GENERATED: 'rhie:referral:code_generated',
  REFERRAL_CODE_SHARED: 'rhie:referral:code_shared',
  REFERRAL_INVITED: 'rhie:referral:invited',
  REFERRAL_PENDING: 'rhie:referral:pending',
  REFERRAL_COMPLETED: 'rhie:referral:completed',
  REFERRAL_REWARD_EARNED: 'rhie:referral:reward_earned',
  REFERRAL_MILESTONE: 'rhie:referral:milestone', // 5, 10, 25 kapı açma
  
  // İlham Paylaşımı (Social Share) Events
  SHARE_MILESTONE_TRIGGERED: 'rhie:share:milestone_triggered',
  SHARE_MILESTONE_COMPLETED: 'rhie:share:completed',
  SHARE_TO_FACEBOOK: 'rhie:share:facebook',
  SHARE_TO_TWITTER: 'rhie:share:twitter',
  SHARE_TO_WHATSAPP: 'rhie:share:whatsapp',
  SHARE_LINK_COPIED: 'rhie:share:link_copied',
  
  // Dönüşüm Adımları (7, 21, 30, 66 gün)
  MILESTONE_7_DAYS: 'rhie:milestone:7_days',
  MILESTONE_21_DAYS: 'rhie:milestone:21_days',
  MILESTONE_30_DAYS: 'rhie:milestone:30_days',
  MILESTONE_66_DAYS: 'rhie:milestone:66_days',
  MILESTONE_100_DAYS: 'rhie:milestone:100_days',
  
  // Growth Insights
  GROWTH_INSIGHT_READY: 'rhie:growth:insight_ready',
  VIRAL_POTENTIAL_DETECTED: 'rhie:growth:viral_potential',
  
  // Zihin Kılavuzu Events (Rehber)
  HINT_SHOWN: 'rhie:hint:shown',
  HINT_DISMISSED: 'rhie:hint:dismissed',
  ONBOARDING_STARTED: 'rhie:onboarding:started',
  ONBOARDING_COMPLETED: 'rhie:onboarding:completed',
  GUIDE_INTENSITY_CHANGED: 'rhie:guide:intensity_changed',
  
  // UI Events
  PLAYER_OPENED: 'rhie:player:opened',
  PLAYER_CLOSED: 'rhie:player:closed',
  CINEMA_MODE_ENTERED: 'rhie:cinema:entered',
  CINEMA_MODE_EXITED: 'rhie:cinema:exited',
  
  // Session Events
  SESSION_STARTED: 'rhie:session:started',
  SESSION_ENDED: 'rhie:session:ended',
  
  // Daily Events
  DAILY_RITUAL_ASSIGNED: 'rhie:daily:assigned',
  DAILY_GOAL_SET: 'rhie:daily:goal_set',
  DAILY_GOAL_ACHIEVED: 'rhie:daily:goal_achieved'
};

// ==========================================
// RISK SEVİYELERİ
// ==========================================

export const DROP_RISK_LEVELS = {
  LOW: { min: 0, max: 25, label: 'Düşük', color: '#34D399' },
  MEDIUM: { min: 26, max: 50, label: 'Orta', color: '#FFA94D' },
  HIGH: { min: 51, max: 75, label: 'Yüksek', color: '#F97316' },
  CRITICAL: { min: 76, max: 100, label: 'Kritik', color: '#EF4444' }
};

// ==========================================
// SEVİYE BAZLI REHBER YOĞUNLUĞU
// ==========================================

export const GUIDE_INTENSITY = {
  Farkındalık: { level: 'high', frequency: 'frequent', detail: 'verbose' },
  Uyanış: { level: 'medium', frequency: 'balanced', detail: 'standard' },
  Dönüşüm: { level: 'low', frequency: 'minimal', detail: 'brief' },
  Ustalık: { level: 'minimal', frequency: 'rare', detail: 'minimal' },
  Mentor: { level: 'off', frequency: 'never', detail: 'none' }
};

// ==========================================
// P3 - MAINTENANCE ENGINE CONSTANTS
// ==========================================

export const STREAK_SHIELD_CONFIG = {
  maxShieldsPerMonth: 2,
  shieldDurationDays: 1,
  cooldownDays: 7,
  vipBonusShields: 1
};

export const BUFFER_DAYS_CONFIG = {
  initialBufferDays: 1,
  earnedPerWeek: 0.5, // 1 buffer every 2 weeks
  maxBuffer: 3,
  useThreshold: 3 // Days inactive before auto-use
};

export const GRACE_MODE_CONFIG = {
  minDays: 1,
  maxDays: 14,
  reasons: ['tatil', 'sağlık', 'yoğunluk', 'diğer'],
  streakPreservation: true,
  xpPenalty: 0 // No penalty during grace
};

export const WEEKLY_RHYTHM_CONFIG = {
  targetDaysPerWeek: 5,
  minForMaintenance: 3,
  perfectWeekBonus: 50, // Zihin Puanı
  consistencyMultiplier: 1.1
};

export const RECOVERY_RITUAL_CONFIG = {
  maxDurationMinutes: 5,
  xpMultiplier: 1.5, // Dönüş bonusu için Zihin Puanı çarpanı
  streakRecoveryWindow: 48 // Saat
};

// ==========================================
// P4 - GROWTH LAYER CONSTANTS
// ==========================================

export const REFERRAL_CONFIG = {
  // Zihin Puanı Kazancı
  referrerReward: {
    zp: 50,              // ZP (Zihin Puanı)
    streakShield: 1,     // Süreklilik kalkanı bonusu
    premiumDays: 0       // Premium gün (VIP için)
  },
  refereeReward: {
    zp: 25,              // Kapı açılan kişi için ZP
    bufferDay: 1         // Bonus tampon gün
  },
  // Dönüşüm Adımı Ödülleri
  milestones: {
    5: { badge: 'Dönüşüm Elçisi', zp: 100, premiumDays: 3 },
    10: { badge: 'Uyanış Çemberi Öncüsü', zp: 250, premiumDays: 7 },
    25: { badge: 'Zihin Mimarı', zp: 500, premiumDays: 14 }
  },
  // Limitler
  maxPendingInvites: 10,
  inviteExpiryDays: 30,
  minStreakToRefer: 3 // Minimum ritüel sürekliliği
};

export const SHARE_CONFIG = {
  milestones: [7, 21, 30, 66, 100],
  platforms: ['facebook', 'twitter', 'whatsapp', 'copy'],
  shareTexts: {
    7: '✧ 7 günlük ritüel sürekliliğimi tamamladım. Bilinçaltı dönüşüm yolculuğuma sen de katıl.',
    21: '◇ 21 gün. Artık bu bir yaşam biçimi. Dönüşüm yolculuğuna başla.',
    30: '∗ 30 günlük dönüşüm adımı. Zihnimin potansiyeli açığa çıkıyor. Sen de keşfet.',
    66: '◈ 66 gün. Bilim kalıcılığı onaylar. Ben yaşıyorum.',
    100: '✦ 100 gün. Ustalık aşamasına ulaştım. Bu yolculuk seninle de başlasın.'
  }
};

export const OAUTH_PROVIDERS = {
  google: {
    name: 'Google',
    icon: 'google',
    color: '#4285F4',
    enabled: true
  },
  facebook: {
    name: 'Facebook',
    icon: 'facebook',
    color: '#1877F2',
    enabled: true
  }
};

// Legacy alias for Zihin Kılavuzu compatibility
export const ZIHIN_EVENTS = RHIE_EVENTS;

// ==========================================
// EVENT BUS CLASS
// ==========================================

class RHIEEventBus {
  constructor() {
    this.listeners = new Map();
    this.eventHistory = [];
    this.maxHistorySize = 100;
    this.debug = process.env.NODE_ENV === 'development';
  }
  
  /**
   * Subscribe to an event
   * @param {string} event - Event name
   * @param {Function} callback - Callback function
   * @returns {Function} Unsubscribe function
   */
  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event).add(callback);
    
    // Return unsubscribe function
    return () => {
      this.listeners.get(event)?.delete(callback);
    };
  }
  
  /**
   * Subscribe to event once
   * @param {string} event - Event name
   * @param {Function} callback - Callback function
   */
  once(event, callback) {
    const unsubscribe = this.on(event, (data) => {
      unsubscribe();
      callback(data);
    });
  }
  
  /**
   * Emit an event
   * @param {string} event - Event name
   * @param {Object} data - Event data
   */
  emit(event, data = {}) {
    const eventData = {
      ...data,
      event,
      timestamp: Date.now(),
      id: `${event}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    };
    
    // Store in history
    this.eventHistory.push(eventData);
    if (this.eventHistory.length > this.maxHistorySize) {
      this.eventHistory.shift();
    }
    
    // Debug logging
    if (this.debug) {
      console.log(`[R.H.I.E.] 📡 ${event}`, data);
    }
    
    // Notify listeners
    const callbacks = this.listeners.get(event);
    if (callbacks) {
      callbacks.forEach(callback => {
        try {
          callback(eventData);
        } catch (error) {
          console.error(`[R.H.I.E.] Error in event handler for ${event}:`, error);
        }
      });
    }
    
    // Also emit to wildcard listeners
    const wildcardCallbacks = this.listeners.get('*');
    if (wildcardCallbacks) {
      wildcardCallbacks.forEach(callback => {
        try {
          callback(eventData);
        } catch (error) {
          console.error(`[R.H.I.E.] Error in wildcard handler:`, error);
        }
      });
    }
  }
  
  /**
   * Remove all listeners for an event
   * @param {string} event - Event name
   */
  off(event) {
    this.listeners.delete(event);
  }
  
  /**
   * Clear all listeners
   */
  clear() {
    this.listeners.clear();
  }
  
  /**
   * Get event history
   * @param {string} eventFilter - Optional event type filter
   * @returns {Array} Event history
   */
  getHistory(eventFilter = null) {
    if (eventFilter) {
      return this.eventHistory.filter(e => e.event === eventFilter);
    }
    return [...this.eventHistory];
  }
  
  /**
   * Get last event of type
   * @param {string} event - Event name
   * @returns {Object|null} Last event data
   */
  getLastEvent(event) {
    const filtered = this.eventHistory.filter(e => e.event === event);
    return filtered[filtered.length - 1] || null;
  }
}

// Singleton instance
export const rhieEventBus = new RHIEEventBus();

// Legacy alias
export const zihinEventBus = rhieEventBus;

export default rhieEventBus;
